import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '../../../../components';
import { MAX_PROMPT_CHARS } from '../../art-style-api';
import { Root, InputWrap, Input, Count, Helper } from './DirectionField.styles';

export type DirectionFieldProps = {
  value: string;
  onChange: (value: string) => void;
};

/**
 * The owner's direction: free text that steers what the mood board sets (it wins when the two disagree).
 */
export const DirectionField = ({ value, onChange }: DirectionFieldProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Root>
      <InputWrap>
        <Input
          value={value}
          rows={3}
          aria-label={t('Direction')}
          aria-describedby="art-style-direction-count"
          placeholder={t('Describe the feel you want, in your own words.')}
          onChange={(event) => onChange(event.target.value.slice(0, MAX_PROMPT_CHARS))}
        />
        <Count id="art-style-direction-count">
          <Text raw text={`${value.length}/${MAX_PROMPT_CHARS}`} tag="span" />
        </Count>
      </InputWrap>
      <Helper text="Steers what the mood board sets. Your words win when they disagree." tag="span" />
    </Root>
  );
};

export default DirectionField;
